module.exports = __webpack_public_path__ + "static/media/1003001BE.e37c0eb6.jpg";